var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nf-register"}},[(!_vm.showCNPJForm)?_c('div',{staticClass:"contas"},[_c('AccountsList')],1):_c('div',{staticClass:"new-account"},[_c('CNPJForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }